import MapPage from 'CitizenPortal/pages/Map'
import { PageHead } from 'components'

export default function Page() {
  return (
    <>
      <PageHead title="Mapa | Portal Cidadão" />

      <MapPage />
    </>
  )
}

export const getServerSideProps = async () => {
  return {
    props: {},
  }
}
